import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="max-w-xl mx-auto text-center" data-id="element-91">
      <p className="text-xs text-brand-medium-grey mb-8 font-bold uppercase tracking-[0.2em]" data-id="element-92">
        ⏰ El precio de lanzamiento termina en:
      </p>
      <div className="flex items-center justify-center gap-4 mb-8" data-id="element-93">
        <TimeBlock value={formatTime(timeLeft.hours)} label="HRS" data-id="element-94" />
        <span className="text-brand-gold-warm text-2xl font-bold mb-6" data-id="element-95">:</span>
        <TimeBlock value={formatTime(timeLeft.minutes)} label="MIN" data-id="element-96" />
        <span className="text-brand-gold-warm text-2xl font-bold mb-6" data-id="element-97">:</span>
        <TimeBlock value={formatTime(timeLeft.seconds)} label="SEG" data-id="element-98" />
      </div>
      <p className="text-[10px] text-brand-terracotta font-bold uppercase tracking-widest" data-id="element-99">
        Después sube de precio y no vuelve a bajar.
      </p>
    </div>;
}
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-100">
      <div className="bg-white border border-brand-petroleum/5 rounded-2xl px-6 py-4 min-w-[80px] text-center shadow-premium" data-id="element-101">
        <div className="text-3xl font-bold text-brand-petroleum" data-id="element-102">{value}</div>
      </div>
      <div className="text-[9px] text-brand-medium-grey font-bold uppercase tracking-widest mt-3" data-id="element-103">
        {label}
      </div>
    </div>;
}